var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HarvestAlreadyRunningError } from "../types/Admin";
import { getHeaders, hasHttpResponse } from "../utils/apiUtils";
import { API_PATHS, legalDepositsAdminHarvestLibrary, legalDepositsHarvestSkcResume, } from "../types/apiPaths";
export var triggerBulkHarvest = function (kyInstance, from, force) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_HARVEST_SKC_BULK, {
                        json: { from: from, force: force },
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Trigger error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                if (error_1 instanceof HarvestAlreadyRunningError) {
                    throw error_1;
                }
                if (hasHttpResponse(error_1) && error_1.response.status === 409) {
                    throw new HarvestAlreadyRunningError();
                }
                console.error("Error triggering bulk harvest:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchHarvestStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_HARVEST_SKC_STATUS, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_2 = _a.sent();
                console.error("Error fetching harvest status:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var resumeHarvest = function (kyInstance, runId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(legalDepositsHarvestSkcResume(runId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Resume error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                if (hasHttpResponse(error_3) && error_3.response.status === 409) {
                    throw new HarvestAlreadyRunningError();
                }
                console.error("Error resuming harvest:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var retryFailedRecords = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_HARVEST_SKC_RETRY_FAILED, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Retry error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_4 = _a.sent();
                if (hasHttpResponse(error_4) && error_4.response.status === 409) {
                    throw new HarvestAlreadyRunningError();
                }
                console.error("Error retrying failed records:", error_4);
                throw error_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchRetryFailedStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_HARVEST_SKC_RETRY_FAILED_STATUS, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_5 = _a.sent();
                console.error("Error fetching retry status:", error_5);
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var realignSchedules = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ADMIN_REALIGN_SCHEDULES, { headers: getHeaders(), timeout: 600000 })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Realign error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_6 = _a.sent();
                console.error("Error realigning schedules:", error_6);
                throw error_6;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var stopHarvest = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_HARVEST_SKC_STOP, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Stop error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_7 = _a.sent();
                console.error("Error stopping harvest:", error_7);
                throw error_7;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchLibraryHarvestStatuses = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_ADMIN_HARVEST_LIBRARIES_STATUS, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_8 = _a.sent();
                console.error("Error fetching library harvest status:", error_8);
                throw error_8;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var startLibraryHarvestAll = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_ADMIN_HARVEST_LIBRARIES, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Trigger error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_9 = _a.sent();
                console.error("Error starting harvest of all libraries:", error_9);
                throw error_9;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var startLibraryHarvest = function (kyInstance, libraryId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(legalDepositsAdminHarvestLibrary(libraryId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Trigger error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_10 = _a.sent();
                console.error("Error starting library harvest:", error_10);
                throw error_10;
            case 4: return [2 /*return*/];
        }
    });
}); };
